import createSafeStorage from './safeStorageCreator';
export default createSafeStorage('sessionStorage');
